import React, { FC, useState, useCallback } from 'react'
import { ProductForSearch } from '../types'

interface ProductFilterProps {
  onProductSelect: (product: ProductForSearch) => void
  onSearch: (term: string) => Promise<ProductForSearch[]>
  loading: boolean
  error: string | null
}

/**
 * Componente de Filtro/Busca de Produtos
 * Inspirado no padrão do Food SmartOrder
 */
export const ProductFilter: FC<ProductFilterProps> = ({
  onProductSelect,
  onSearch,
  loading,
  error,
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [products, setProducts] = useState<ProductForSearch[]>([])
  const [searched, setSearched] = useState(false)

  const handleSearch = useCallback(async () => {
    if (searchTerm.trim().length === 0) {
      setProducts([])
      return
    }

    const results = await onSearch(searchTerm)
    setProducts(results)
    setSearched(true)
  }, [searchTerm, onSearch])

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  const handleSelectProduct = (product: ProductForSearch) => {
    onProductSelect(product)
  }

  return (
    <div className='card card-bordered'>
      <div className='card-header'>
        <h3 className='card-title'>Buscar Produto</h3>
      </div>

      <div className='card-body'>
        {/* ERRO */}
        {error && (
          <div className='alert alert-danger' role='alert'>
            <i className='bi bi-exclamation-triangle me-2'></i>
            {error}
          </div>
        )}

        {/* BUSCA */}
        <div className='row mb-4'>
          <div className='col-md-8'>
            <input
              type='text'
              className='form-control'
              placeholder='Digite código ou nome do produto...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={loading}
            />
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-primary w-100'
              onClick={handleSearch}
              disabled={loading || !searchTerm.trim()}
            >
              {loading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2'></span>
                  Buscando...
                </>
              ) : (
                <>
                  <i className='bi bi-search me-2'></i>
                  Buscar
                </>
              )}
            </button>
          </div>
        </div>

        {/* RESULTADOS */}
        {searched && products.length === 0 && !loading && (
          <div className='alert alert-info' role='alert'>
            Nenhum produto encontrado
          </div>
        )}

        {products.length > 0 && (
          <div className='table-responsive'>
            <table className='table table-hover'>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Categoria</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id}>
                    <td>
                      <code>{product.code}</code>
                    </td>
                    <td>{product.name}</td>
                    <td>{product.classification?.name || '-'}</td>
                    <td>
                      <button
                        className='btn btn-sm btn-info'
                        onClick={() => handleSelectProduct(product)}
                      >
                        <i className='bi bi-arrow-right me-2'></i>
                        Selecionar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
